import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'capitalizeFirstLetter' })
export class CapitalizeFirstLetterPipe implements PipeTransform {

    transform(value: string): string {

        if (!value) {
            return '';
        }

        if (value.length == 1) {
            return value.charAt(0).toUpperCase();
        } else {
            return value.charAt(0).toUpperCase() + value.substr(1).toLowerCase();
        }

    }

}
